import script from "./NewsPageStoryDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageStoryDropdown.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageStoryDropdown.vue?vue&type=style&index=0&id=784fb9ed&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-784fb9ed"]])

export default __exports__